export default "__VITE_ASSET__DS4P9$L6__"